import { defineMessages } from 'react-intl';

export const practiceTrialModalMessages = defineMessages({
  title: {
    defaultMessage: 'Enjoy premium features and collaboration, on us.',
    id: 'qhIBxOPwFd',
    description: 'Title on the Practice plan trial start modal',
  },
  subtitle: {
    defaultMessage: 'You have 14 free days on the Practice plan. No commitment.',
    id: 'zLMeWEIGRr',
    description: 'Subtitle on the Practice plan trial start modal',
  },
  cta: {
    defaultMessage: 'Invite team members',
    id: '0fo99OqxYb',
    description:
      'Primary CTA on the Practice plan trial start modal when the invite-team flow will open',
  },
  gotIt: {
    defaultMessage: 'Got it',
    id: 'c0lsQv09kE',
    description:
      'Primary CTA on the Practice plan trial start modal when invite-team was already done in onboarding',
  },
  tryOnMyOwn: {
    defaultMessage: 'I’ll try Heidi on my own',
    id: 'Gy9c+LaCfq',
    description:
      'Secondary CTA on the Practice plan trial start modal that skips the invite-team step',
  },
  footerText: {
    defaultMessage:
      'At the end of your 14 days you’ll be automatically downgraded to the Free plan if you don’t want to stay on Practice.',
    id: '1tortdkew9',
    description: 'Footer disclaimer on the Practice plan trial start modal',
  },
});
